import React, { useState, useEffect } from 'react';
import { Navbar } from '@/components/Navbar';
import { WebinarSection } from '@/components/WebinarSection';
import { PricingSection } from '@/components/PricingSection';
import { Footer } from '@/components/Footer';
import { Toaster } from '@/components/ui/sonner';

export default function WebinarPage() {
  const [showPricing, setShowPricing] = useState(false);

  useEffect(() => {
    // Track this visit
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track/visit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page: '/webinar' }),
    }).catch(() => {});

    // If visitor already watched 90%+ in a prior session, show pricing immediately
    const reached = localStorage.getItem('webinar_90_reached');
    if (reached === 'true') {
      setShowPricing(true);
    }

    // Listen for the 90% event fired during video playback
    const handleWebinar90 = () => {
      setShowPricing(true);
    };

    window.addEventListener('webinar-90-percent', handleWebinar90);
    return () => {
      window.removeEventListener('webinar-90-percent', handleWebinar90);
    };
  }, []);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#000000' }}>
      <Navbar />
      <WebinarSection />

      {/* PricingSection only reveals after 90% of the webinar video is watched */}
      {showPricing && <PricingSection />}

      <Footer />
      <Toaster theme="dark" richColors position="top-center" />
    </div>
  );
}
